import * as Yup from "yup";

export const bidFormValidationSchema = Yup.object().shape({
  email: Yup.string().required(" ").email("Invalid email format."),
  blindBid: Yup.boolean(),
  customerRate: Yup.string()
    .required(" ")
    .test({
      name: "is-customerRate",
      skipAbsent: true,
      test(value, ctx) {
        if (!value.match(/^[0-9]*\.?[0-9]*\.?$/g)) {
          return ctx.createError({ message: "Only digits are allowed." });
        }
        if (value.length > 2 && !value.match(/^\d+\.?\d{1,2}$/g)) {
          return ctx.createError({ message: "Only 2 digits allowed after the '.'" });
        }
        return true;
      },
    }),
  driverRate: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid
      ? schema.required(" ").test({
          name: "is-driverRate",
          skipAbsent: true,
          test(value, ctx) {
            if (!value.match(/^[0-9]*\.?[0-9]*\.?$/g)) {
              return ctx.createError({ message: "Only digits are allowed." });
            }
            if (value.length > 2 && !value.match(/^\d+\.?\d{1,2}$/g)) {
              return ctx.createError({ message: "Only 2 digits allowed after the '.'" });
            }
            return true;
          },
        })
      : schema
          .nullable()
          .notRequired()
          .when("driverRate", {
            is: (value) => value?.length,
            then: (rule) =>
              rule.test({
                name: "is-driverRate",
                skipAbsent: true,
                test(value, ctx) {
                  if (!value.match(/^[0-9]*\.?[0-9]*\.?$/g)) {
                    return ctx.createError({ message: "Only digits are allowed." });
                  }
                  if (value.length > 2 && !value.match(/^\d+\.?\d{1,2}$/g)) {
                    return ctx.createError({
                      message: "Only 2 digits allowed after the '.'",
                    });
                  }
                  return true;
                },
              }),
          });
  }),
  unit: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid ? schema.required(" ") : schema.notRequired();
  }),
  truckType: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid ? schema.required(" ") : schema.notRequired();
  }),
  length: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid
      ? schema.required(" ").matches(/^\d+$/, "Only digits are allowed.")
      : schema
          .nullable()
          .notRequired()
          .when("length", {
            is: (value) => value?.length,
            then: (rule) => rule.matches(/^\d+$/, "Only digits are allowed."),
          });
  }),
  width: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid
      ? schema.required(" ").matches(/^\d+$/, "Only digits are allowed.")
      : schema
          .nullable()
          .notRequired()
          .when("width", {
            is: (value) => value?.length,
            then: (rule) => rule.matches(/^\d+$/, "Only digits are allowed."),
          });
  }),
  height: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid
      ? schema.required(" ").matches(/^\d+$/, "Only digits are allowed.")
      : schema
          .nullable()
          .notRequired()
          .when("height", {
            is: (value) => value?.length,
            then: (rule) => rule.matches(/^\d+$/, "Only digits are allowed."),
          });
  }),
  milesOut: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid
      ? schema.required(" ").matches(/^\d+$/, "Only digits are allowed.")
      : schema
          .nullable()
          .notRequired()
          .when("milesOut", {
            is: (value) => value?.length,
            then: (rule) => rule.matches(/^\d+$/, "Only digits are allowed."),
          });
  }),
  eta: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid ? schema.required(" ") : schema.notRequired();
  }),
  transitTime: Yup.string().when("blindBid", ([blindBid], schema) => {
    return !blindBid ? schema.required(" ") : schema.notRequired();
  }),
  notes: Yup.string().max(255, "Notes must be under 255 characters."),
});
